import SizeUtility from '../../../js/Utilities/SizeUtility.js';
import EscapeManager from '../../../js/Managers/EscapeManager.js';

class SimpleNavItem extends HTMLElement {
  #open = false;
  submenu = null;

  constructor() {
    super();
    this.submenu = this.querySelector('.simple-nav-item__submenu');
    this.button = this.querySelector('.simple-nav-item__expander');

    this.setAttribute('data-menu-expanded', 'false');

    if (!this.submenu) return;

    this.#onClose();
    this.submenuID = this.submenu.getAttribute('id');
    this.escapeManagerID = `closeReportMenu-${this.submenuID}`;

    this._onButtonClick = this.onButtonClick.bind(this);
    this._onButtonMouseEnter = this.onButtonMouseEnter.bind(this);
    this._listenForOutsideClick = this.listenForOutsideClick.bind(this);
  }
  connectedCallback() {
    if (!this.submenu) return;
    this.addEventListeners();
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', this._onButtonClick);

    this.addEventListener('mouseenter', this._onButtonMouseEnter);
  }
  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClick);

    this.removeEventListener('mouseenter', this._onButtonMouseEnter);
  }

  onButtonClick() {
    this.open = !this.open;
  }

  onButtonMouseEnter() {
    if (!SizeUtility.isScreenGtLg()) {
      return;
    }
    this.open = true;
  }

  #onClose() {
    if (this.button) {
      this.button.setAttribute('aria-expanded', 'false');
    }
    if (this.submenu) this.submenu.setAttribute('hidden', true);

    this.setAttribute('data-menu-expanded', 'false');

    EscapeManager.remove(this.escapeManagerID);
    this.removeOpenListeners();
  }

  #onOpen() {
    if (this.button) {
      this.button.setAttribute('aria-expanded', 'true');
    }
    if (this.submenu) this.submenu.removeAttribute('hidden');

    this.setAttribute('data-menu-expanded', 'true');

    EscapeManager.add(this.escapeManagerID, () => {
      this.open = false;
    });
    this.addOpenListeners();

    this.dispatchEvent(new CustomEvent('simple-nav-open', { bubbles: true }));
  }

  listenForOutsideClick(evt) {
    if (!this.contains(evt.target)) {
      this.open = false;
    }
  }

  addOpenListeners() {
    document.addEventListener('click', this._listenForOutsideClick);
  }

  removeOpenListeners() {
    document.removeEventListener('click', this._listenForOutsideClick);
  }

  get open() {
    return this.#open;
  }

  set open(value) {
    this.#open = value;

    if (this.#open) {
      this.#onOpen();
    } else {
      this.#onClose();
    }
  }
}

class SimpleNav extends HTMLElement {
  constructor() {
    super();
    this.SimpleNavItems = Array.from(this.querySelectorAll('simple-nav-item'));
  }
  connectedCallback() {
    this.addEventListeners();
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.SimpleNavItems.forEach(item => {
      item._closeOtherMenus = this.closeOtherMenus.bind(this, item);
      item.addEventListener('simple-nav-open', item._closeOtherMenus);
    });
  }
  removeEventListeners() {
    this.SimpleNavItems.forEach(item => {
      item.removeEventListener('simple-nav-open', item._closeOtherMenus);
    });
  }

  getOpenCount() {
    return this.SimpleNavItems.filter(item => item.open).length;
  }

  closeOtherMenus(item = false) {
    this.SimpleNavItems.forEach(navItem => {
      if (navItem !== item) navItem.open = false;
    });

    // Scroll this to top of item if not false
    if (item) {
      const itemTop = item.getBoundingClientRect().top;
      const navTop = this.getBoundingClientRect().top;
      this.scrollTo({ left: 0, top: itemTop - navTop, behavior: 'instant' });
    }
  }
}

customElements.define('simple-nav-item', SimpleNavItem);
customElements.define('simple-nav', SimpleNav);
